module.exports = __webpack_public_path__ + "static/media/Twitter_bird_logo_2012.f6de4a78.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/Twitter_bird_logo_2012.svg
// module id = 862
// module chunks = 0